import './bootstrap'
import ElementHelper from './helpers/Element'

/**
 * Application class  
 * Contains static methods for initializing the application  
 * Just for convenience and readability
 */
class App {
  /**
   * Initialize the application
   */
  static init() {
    document.addEventListener('DOMContentLoaded', () => {
      this.calcAndSaveScrollbarWidth()
      this.wrapTablesInScrollableContainers()
      this.initHeroSlider()
      this.createCookieStorage()
      Alpine.start()
    })
  }

  /**
   * Calculate and save scrollbar width to CSS variable  
   * Used for breakout sections with horizontal scroll
   */
  static calcAndSaveScrollbarWidth() {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth
    document.documentElement.style.setProperty(
      '--scrollbar-width',
      `${scrollbarWidth}px`
    )
  }

  /**
   * Wrap tables in scrollable containers
   * Used for tables that are too wide to fit on the page
   */
  static wrapTablesInScrollableContainers() {
    const tables = document.querySelectorAll('table')

    tables.forEach(table => {
      if (ElementHelper(table.parentElement).hasAllClasses('overflow-auto', 'max-w-full', 'block')) {
        return
      }

      const scrollableContainer = document.createElement('div')
      scrollableContainer.className = 'overflow-auto max-w-full block'
      table.parentNode.replaceChild(scrollableContainer, table)
      scrollableContainer.appendChild(table)
    })
  }

  /**
   * Initialize homepage hero slider  
   * Needed for custom pagination - can't be set via html attributes
   * @see https://swiperjs.com/element
   * @see https://swiperjs.com/swiper-api#pagination
   */
  static initHeroSlider() {
    const swiper = document.querySelector('swiper-container[data-swiper="hero"]')

    if (!swiper) return

    const f = n => n.toString().padStart(2, '0')
    Object.assign(swiper, {
      loop: true,
      spaceBetween: 16,
      speed: 1500,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: false
      },
      effect: 'creative',
      creativeEffect: {
        prev: {
          shadow: true,
          translate: ["-20%", 0, -1],
        },
        next: {
          translate: ["100%", 0, 0],
        },
      },
      on: {
        autoplayTimeLeft: (s, time, progress) => {
          // `setProperty` should be applied to `parentElement` specifically,
          // when applied to `swiper` directly - `autoplay` is set to `paused`
          swiper.parentElement.style.setProperty('--_progress', `${(1 - progress) * 100}%`)
        }
      },
      breakpoints: {
        0: {
          pagination: {
            el: '[data-control="pagination"]',
            type: 'bullets'
          }
        },
        1024: {
          pagination: {
            el: '[data-control="pagination"]',
            type: 'fraction',
            formatFractionCurrent: f,
            formatFractionTotal: f
          },
          navigation: {
            prevEl: '[data-control="prev"]',
            nextEl: '[data-control="next"]',
          },
        }
      }
    })
    swiper.initialize()
  }


  /**
   * Create cookie storage
   * Used for storing data in cookies
   */
  static createCookieStorage() {
    const cookieStorage = {
      getItem(key) {
        const cookies = document.cookie.split(";")
        for (let i = 0; i < cookies.length; i++) {
          const cookie = cookies[i].split("=")
          if (key == cookie[0].trim()) {
            return decodeURIComponent(cookie[1])
          }
        }
        return null
      },
      setItem(key, value) {
        document.cookie = key+' = '+encodeURIComponent(value)
      }
    }

    window.cookieStorage = cookieStorage
  }
}

App.init()
